export default "__VITE_ASSET__B3j2v7O0__"